import {
  IsNotEmpty,
  IsOptional,
  IsArray,
  IsDate,
  IsInt,
  Min,
  ValidateNested,
  IsIn,
  IsBoolean,
} from "class-validator";
import { Type } from "class-transformer";

import { Constants } from "@eagerdog/constants";
import { AddressDto, ContactDto } from "../common";
import { ArbitrationAddressDto } from "../common";

import { EventArmNumberConfigDto } from "./event-arm-number-config.dto";
import { GateStewardDto } from "./gate-steward.dto";

export class EventDto {
  //
  @IsOptional()
  club_name?: string = "";

  @IsNotEmpty()
  title: string = "";

  @IsOptional()
  notes?: string = "";

  @IsNotEmpty()
  @IsIn(Object.values(Constants.sanctioning_club))
  sanctioning_club: string;

  @IsNotEmpty()
  conditions: string = "";

  @IsDate()
  start_date: Date;

  @IsInt()
  @Min(1)
  number_of_days: number;

  @IsOptional()
  @IsDate()
  end_date?: Date;

  @IsOptional()
  @IsIn(Object.values(Constants.event_status))
  status?: string;

  @IsOptional()
  @IsDate()
  publish_at?: Date;

  @IsOptional()
  @IsDate()
  registration_end_date?: Date;

  @IsOptional()
  premium_file_url?: string = "";

  @IsOptional()
  flyer_image_url?: string = "";

  @IsOptional()
  @IsBoolean()
  allow_paper_registration?: boolean;

  @IsOptional()
  @ValidateNested()
  @Type(() => AddressDto)
  paper_registration_address?: AddressDto;

  @IsNotEmpty()
  @IsInt()
  @Min(1)
  arm_number_start: number = 100;

  @IsOptional()
  @IsBoolean()
  auto_assign_armband_numbers?: boolean;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => EventArmNumberConfigDto)
  arm_numbers_config?: EventArmNumberConfigDto[];

  @ValidateNested()
  @Type(() => AddressDto)
  address: AddressDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => ArbitrationAddressDto)
  arbitration_address?: ArbitrationAddressDto;

  @IsOptional()
  registration_message?: string;

  @IsOptional()
  timezone?: string;

  @IsOptional()
  waiver?: string;

  @IsOptional()
  club_policies?: string;

  @IsOptional()
  @IsBoolean()
  is_archived?: boolean;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ContactDto)
  contacts: ContactDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => GateStewardDto)
  gate_stewards?: GateStewardDto[];

  @IsOptional()
  num_rings?: number;

  @IsOptional()
  @IsBoolean()
  is_lottery?: boolean;

  @IsOptional()
  @IsDate()
  lottery_ran_at?: Date;

  @IsOptional()
  @IsDate()
  lottery_run_date?: Date;

  @IsOptional()
  @IsDate()
  lottery_end_date?: Date;

  @IsOptional()
  @IsBoolean()
  waitlist_closed?: boolean;

  @IsOptional()
  @IsIn(Object.values(Constants.armband_generation))
  armband_generation?: string;

  @IsOptional()
  @IsIn(Object.values(Constants.armband_order_type))
  armband_order_type?: string;

  @IsOptional()
  @IsBoolean()
  concurrent_schedule?: boolean;
}
